import { map, pipe } from 'rxjs';

export const filterArray = <T>(filterFn: (item: T) => boolean) => {
  return pipe(map((array: T[]) => array.filter((item) => filterFn(item))));
};

export const mapArray = <T, R>(mapFn: (item: T) => R) => {
  return pipe(map((array: T[]) => array.map((item) => mapFn(item))));
};
